import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Grid,Typography, Select, IconButton } from '@material-ui/core';

import {
  Refresh as RefreshIcon
} from '@material-ui/icons';

// Shared layouts
import { Dashboard as DashboardLayout } from 'layouts';

// Custom components
import {
  TrendChart,
  ImpressionChart,
  Impressions,
} from './components';

import compose from 'recompose/compose';
import { connect } from "react-redux";
import { getCids } from "../../actions/authActions";
import api from '../../api';

import SelectBar from 'react-select'

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  }
});

const colourStyles = {
  control: styles => ({ ...styles, fontFamily: 'Roboto' }),
  option: styles => ({ ...styles, fontFamily: 'Roboto'})
};

const timeRangeList = [
  'Last Hour',
  'Last 24 Hours',
  'Last 7 Days',
  'Last 30 Days',
  'Previous Month'
];

const colors = [
  '#E12B17',
  '#E1AA17',
  '#CDF00E',
  '#17EEB3',
  '#39839B',
  '#2851C8',
  '#9719C0',
  '#D121A9',
  '#F31A20',
  '#5D6545'
];

const pointCnt = [
  60,
  24,
  168,
  720,
  getDaysInMonth(new Date().getFullYear(), new Date().getMonth())*24
];

function getDaysInMonth(year, month) {
 return new Date(year, month, 0).getDate();
}


class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: [],
      cidOption: [],
      timeRange: 0,
      lastUpdated: new Date(),
      data: {
        labels: [],
        datasets: []
      }
    }
  }

  componentDidMount () {
    this.props.getCids(this.props.auth.user.cid);
  }

  async componentWillReceiveProps(next) {
    const cids = next.auth.cids;
    let cidOption = cids.map((cid, index) => {
      return {
        value:index,
        label:cid.name
      };
    });
    let selected = cidOption.filter((cid) => {
      return true;
    });
    if(selected.length > 0) {
      selected = selected.slice(0,0);
    }

   
    const selectedCids = selected.map((option)=>{return cids[option.value];});
    const data = await this.requestData(this.state.timeRange,new Date(), selectedCids);
    this.setState({data, cidOption, selectedOption: selected, lastUpdated: new Date()});
    
  }

  handleChange = async (selectedOption) => {
    if(selectedOption && selectedOption.length > 10) {
      return;
    }
    const allCids= this.props.auth.cids;
    if (selectedOption) {
	    const cids = selectedOption.map((option)=>{return allCids[option.value];});
            if (cids) {
              const data = await this.requestData(this.state.timeRange,new Date(), cids);
	      if (data) {
                this.setState({ data, selectedOption:selectedOption || [] });
              }
	      else {
		const data = {
        labels: [],
        datasets: []
      };
                this.setState({ data,  selectedOption:selectedOption || [] });
	      }

	    }
            
     }
     else {
	  const data = {
        labels: [],
        datasets: []
      };
	  this.setState({ data,  selectedOption:selectedOption || [] });
      }
    

  };

  handleChangeTimeRange = async (event) => {
    const timeRange = parseInt(event.target.value)
    const allCids= this.props.auth.cids;
    const cids = this.state.selectedOption.map((option)=>{return allCids[option.value];});
    const data = await this.requestData(timeRange, new Date(), cids);
    this.setState({
      data,
      timeRange,
      lastUpdated: new Date()
    });
  };

  handleRefresh = async () => {
    const allCids= this.props.auth.cids;
    const cids = this.state.selectedOption.map((option)=>{return allCids[option.value];});
    const data = await this.requestData(this.state.timeRange, new Date(), cids);
    this.setState({
      data,
      lastUpdated: new Date()
    });
  };

  getTS(timeRange, time) {
    let date = new Date(time)
    switch(timeRange) {
      case 0:
        return undefined;
      case 1:
        date.setHours(date.getHours()-24);
        date.setUTCMinutes(0);
        date.setUTCSeconds(0);
        date.setUTCMilliseconds(0);
        return Math.floor(date.getTime() / 1000);
      case 2:
        date.setHours(date.getHours()-168);
        date.setUTCMinutes(0);
        date.setUTCSeconds(0);
        date.setUTCMilliseconds(0);
        return Math.floor(date.getTime() / 1000);
      case 3:
        date.setHours(date.getHours()-720);
        date.setUTCMinutes(0);
        date.setUTCSeconds(0);
        date.setUTCMilliseconds(0);
        return Math.floor(date.getTime() / 1000);
      case 4:
        date.setMonth(date.getMonth()-1);
        date.setUTCDate(1);
        date.setUTCHours(0);
        date.setUTCMinutes(0);
        date.setUTCSeconds(0);
        date.setUTCMilliseconds(0);
        return Math.floor(date.getTime() / 1000);
    }
  }

  createTimeStringMinute(diff, time) {
    let d = new Date(time);
    d.setSeconds(0);
    d.setMinutes( d.getMinutes() - diff );
    return d.getHours()+":"+d.getMinutes();
  }

  createTimeStringHour(diff, time) {
    let d = new Date(time);
    d.setSeconds(0);
    d.setMinutes(0);
    d.setHours( d.getHours() - diff );
    return d.toLocaleDateString()+"-"+(d.getHours());
  }
  
  createTimeStringDate(diff, time) {
    let d = new Date(time);
    d.setSeconds(0);
    d.setMinutes(0);
    d.setHours( d.getHours() - diff );
    return d.toLocaleDateString()+"-"+(d.getHours());
  }

  getLabels(timeRange, time) {
    let count = pointCnt[timeRange];
    switch(timeRange) {
      case 0:
        return Array.from(Array(count).keys()).map(x => this.createTimeStringMinute(count-x, time));
      case 1:
        return Array.from(Array(count).keys()).map(x => this.createTimeStringHour(count-x, time));
      case 2:
      case 3:
        return Array.from(Array(count).keys()).map(x => this.createTimeStringDate(count-x, time));
      case 4:  
        return Array.from(Array(count).keys()).map(x => this.createTimeStringDate(count-x+time.getHours()+(time.getDate()-1)*24, time));
    }
  }

  fillAndReverseData(data) {
    let {timeRange} = this.props
    if(!data)
      return new Array(pointCnt[timeRange]).fill(0);
    if(pointCnt[timeRange] > data.length)
      data = data.concat(new Array(pointCnt[timeRange]-data.length).fill(0));
    else if(pointCnt[timeRange] < data.length)
      data = data.slice(data.length - pointCnt[timeRange]);
    return data.reverse().map((cnt)=>{
      return isNaN(cnt) ? 0 : cnt;
    });
  }

  fillData(data) {
    let {timeRange} = this.props
    if(!data)
      return new Array(pointCnt[timeRange]).fill(0);
    if(pointCnt[timeRange] > data.length)
      data = new Array(pointCnt[timeRange]-data.length).fill(0).concat(data);
    else if(pointCnt[timeRange] < data.length && timeRange!=4)
      data = data.slice(data.length - pointCnt[timeRange]);
    else if(pointCnt[timeRange] < data.length && timeRange==4) // slice from head if timeRange is previous month
      data = data.slice(0, pointCnt[timeRange]);
    return data.map((cnt)=>{
      return isNaN(cnt) ? 0 : cnt;
    });
  }

  async requestData(timeRange, lastUpdated, cids) {
    let newData = {
      labels: this.getLabels(timeRange, lastUpdated),
      datasets: [
      ]
    };
    for(let cid of cids) {
      let res = await api.getChartById(cid.name, this.getTS(timeRange, lastUpdated));
      if(res.error){
        throw res.error;
      }
      newData.datasets.push(
        {
          label: cid.name,
          borderColor: colors[newData.datasets.length%colors.length],
          backgroundColor: colors[newData.datasets.length%colors.length],
          pointRadius: 1,
          fill: false,
          data: this.fillData(res.data.data)
        });
    };
    return newData;
  }

  render() {
    const { classes } = this.props;
    const { timeRange, lastUpdated, data } = this.state;
    const allCids= this.props.auth.cids;
    const cids = this.state.selectedOption.map((option)=>{return allCids[option.value];});
    return (
      <DashboardLayout title="Dashboard">
        <div className={classes.root}>
          <Grid container spacing={4}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <Typography className={classes.title} variant="h4" gutterBottom>
                  Customer ID Filter
              </Typography>
              <SelectBar
                styles={colourStyles}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.cidOption}
                isMulti
              />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
              <Select
                native
                value={timeRange}
                onChange={this.handleChangeTimeRange}
                inputProps={{
                  name: 'timeRange'
                }}>
                <option value={0}>{timeRangeList[0]}</option>
                <option value={1}>{timeRangeList[1]}</option>
                <option value={2}>{timeRangeList[2]}</option>
                <option value={3}>{timeRangeList[3]}</option>
                <option value={4}>{timeRangeList[4]}</option>
              </Select>
              <IconButton
                className={classes.refreshButton}
                onClick={this.handleRefresh}
                variant="text"
              >
              <RefreshIcon />
            </IconButton>
            </Grid>
            {/*
            <Grid item lg={3} sm={6} xl={3} xs={12}>
              <Impressions cids={cids}/>
            </Grid>
            */}
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <TrendChart className={classes.item} lastUpdated={lastUpdated} cids={cids} timeRange={timeRange} data={data} title="Impressions for each customer ID"/>
            </Grid>
            <Grid item lg={12} md={12} xl={12} xs={12}>
              { <ImpressionChart data={data} timeRange={timeRange} lastUpdated={lastUpdated} cids={cids}/> }
            </Grid>
          </Grid>
        </div>
      </DashboardLayout>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  getCids: PropTypes.func.isRequired
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps,{getCids})
)(Dashboard);
